import request from "@/router/request";

export const login = (username, userpwd) => {
    return request({
        url: '/api/auth/login',
        method: "post",
        headers: {
            username,
            userpwd
        },
        meta: {
            isToken: false
        }
    });
}
export const loginByYun = (yunid) => {
    return request({
        url: '/api/auth/LoginByYun',
        method: "post",
        headers: {
            yunid
        },
        meta: {
            isToken: false
        }
    });
}
export const register = (data) => {
    return request({
        url: '/api/auth/Register',
        method: "post",
        data: data,
        meta: {
            isToken: false
        }
    });
}
export const editPwd = (data) => {
    return request({
        url: '/api/auth/editPwd',
        method: "post",
        data: data
    });
}
export const forgetPwd = (data) => {
    return request({
        url: '/api/auth/forgetPwd',
        method: "post",
        data: data,
        meta: {
            isToken: false
        }
    });
}
export const sendSMS = (mobile) => {
    return request({
        url: '/api/auth/sendSMS',
        method: "post",
        data: {
            mobile
        },
        meta: {
            isToken: false
        }
    });
}